export const si = {
  // Navigation
  nav: {
    ats: "ATS",
    jobPostings: "රැකියා දැන්වීම්", 
    candidates: "අපේක්ෂකයින්",
    signIn: "ප්‍රවිශ්ටම්",
    signOut: "පිටවීම",
    postJob: "රැකියාවක් පළ කරන්න",
    findJobs: "රැකියා සොයන්න",
    companies: "සමාගම්",
    jobAlerts: "රැකියා ඇඟවීම්",
    superAdmin: "සුපර් ඇඩ්මින්"
  },

  // Hero Section
  hero: {
    title: "ශ්‍රී ලංකාවේ ඔබේ සිහින\nරැකියාව සොයාගන්න",
    subtitle: "ප්‍රමුඛ පෙළේ සේවායෝජකයින් සමඟ සම්බන්ධ වී රටේ පළමු AI බලගන්වන රැකියා පුවරුවේ දහස් ගණන් අවස්ථා සොයාගන්න",
    searchPlaceholder: "රැකියා නාමය හෝ මූල පද",
    locationPlaceholder: "ස්ථානය තෝරන්න",
    jobTypePlaceholder: "රැකියා වර්ගය",
    searchButton: "රැකියා සොයන්න",
    stats: {
      activeJobs: "ක්‍රියාකාරී රැකියා",
      companies: "සමාගම්", 
      jobSeekers: "රැකියා සොයන්නන්"
    }
  },

  // Job Card
  jobCard: {
    applyNow: "දැන් අයදුම් කරන්න",
    remote: "දුරස්ථ",
    ago: "කට පෙර",
    salary: "වැටුප"
  },

  // Features Section
  features: {
    title: "GreatJobs.lk තෝරා ගන්නේ ඇයි?",
    subtitle: "ශ්‍රී ලංකාවේ වඩාත්ම විශ්වස්ත රැකියා වේදිකාව, දක්ෂතාව සහ අවස්ථාව සම්බන්ධ කරයි.",
    topCompanies: {
      title: "ප්‍රමුඛ සමාගම්",
      description: "ශ්‍රී ලංකාවේ ප්‍රමුඛ සේවායෝජකයින්ගෙන් රැකියා වලට ප්‍රවේශය"
    },
    aiMatching: {
      title: "AI ගැලපීම", 
      description: "අපේක්ෂකයින් සහ රැකියා අවස්ථා අතර බුද්ධිමත් ගැලපීම"
    },
    careerGrowth: {
      title: "වෘත්තීය වර්ධනය",
      description: "ඔබේ වෘත්තීය ජීවිතය ඉදිරියට ගෙන යන අවස්ථා සොයාගන්න"
    },
    qualityVerified: {
      title: "ගුණාත්මක සත්‍යාපිත",
      description: "සියලුම රැකියා දැන්වීම් සත්‍යාපිත සහ නීත්‍යානුකූල ය"
    }
  },

  // Quick Start Section
  quickStart: {
    getStarted: "තත්පර කිහිපයකින් ආරම්භ කරන්න",
    payment: "ක්‍රෙඩිට් කාර්ඩ් හෝ ක්‍රිප්ටෝ ගෙවීම",
    getStartedDesc: "ඔබේ ගිණුම සාදා ක්ෂණිකව රැකියා සඳහා අයදුම් කරන්න",
    paymentDesc: "ඔබේ සියලුම බඳවාගැනීම් අවශ්‍යතා සඳහා නම්‍යශීලී ගෙවීම් විකල්ප"
  },

  // Featured Jobs Section
  featuredJobs: {
    title: "විශේෂාංගගත රැකියා",
    subtitle: "ප්‍රමුඛ සේවායෝජකයින්ගේ ප්‍රීමියම් අවස්ථා සොයාගන්න",
    viewAll: "සියලුම රැකියා බලන්න",
    noJobs: "දැනට විශේෂාංගගත රැකියා නොමැත."
  },

  // CTA Section
  cta: {
    title: "ඔබේ වෘත්තීය ජීවිතය ඊළඟ මට්ටමට ගෙන යාමට සූදානම්ද?",
    subtitle: "GreatJobs.lk හරහා ඔවුන්ගේ සිහින රැකියාව සොයාගත් දහස් ගණන් වෘත්තිකයන්ට එක්වන්න.",
    createAccount: "රැකියා සෙවුම්කරුවෙකුගේ ගිණුමක් සාදන්න",
    postFirstJob: "ඔබේ පළමු රැකියාව පළ කරන්න"
  },

  // Footer
  footer: {
    description: "ශ්‍රී ලංකාවේ ප්‍රමුඛ AI බලගන්වන රැකියා පෝර්ටලය දක්ෂතාව සහ අවස්ථාව සම්බන්ධ කරයි.",
    jobSeekers: "රැකියා සෙවුම්කරුවන්ට",
    employers: "සේවායෝජකයින්ට", 
    support: "සහාය",
    browseJobs: "රැකියා සොයන්න",
    careerAdvice: "වෘත්තීය උපදෙස්",
    resumeBuilder: "ජීව වෘත්තාන්ත සාදන්නා",
    postJobs: "රැකියා පළ කරන්න",
    searchCandidates: "අපේක්ෂකයින් සොයන්න",
    atsIntegration: "ATS ඒකාබද්ධකරණය",
    pricing: "මිලකරණය",
    helpCenter: "උදව් මධ්‍යස්ථානය",
    contactUs: "අප හා සම්බන්ධ වන්න",
    privacyPolicy: "පෞද්ගලිකත්ව ප්‍රතිපත්තිය",
    termsOfService: "සේවා කොන්දේසි",
    yourSafety: "ඔබේ ආරක්ෂාව",
    copyright: "සියලුම අයිතිවාසිකම් ඇවිරිණි."
  },

  appliedJobs: {
    title: "අයදුම් කළ රැකියා",
    description: "ඔබගේ සියලුම රැකියා අයදුම්පත් සොයා බලන්න සහ කළමනාකරණය කරන්න",
    noApplications: "අයදුම්පත් සොයා ගත නොහැක",
    noApplicationsDescription: "ඔබ තවම කිසිදු රැකියාවකට අයදුම් කර නැත. අවස්ථා ගවේෂණය කිරීම ආරම්භ කරන්න!",
    searchPlaceholder: "රැකියා මාතෘකාව, සමාගම හෝ ස්ථානය අනුව සොයන්න...",
    filterByStatus: "තත්ත්වය අනුව පෙරහන්",
    allStatus: "සියලුම තත්ත්වයන්",
    pending: "විභාග අවධිය",
    shortlisted: "කෙටි ලැයිස්තුවට ඇතුළත්",
    interviewing: "සම්මුඛ පරීක්ෂණ",
    offerMade: "දීමනාව ලබා දී ඇත",
    rejected: "ප්‍රතික්ෂේප කරන ලදී",
    withdrawn: "ආපසු ගන්නා ලදී",
    appliedAgo: "අයදුම් කළේ",
    match: "ගැලපීම",
    coverLetter: "ආවරණ ලිපිය",
    cvAttached: "CV ඇමුණුම්",
    viewJob: "රැකියාව බලන්න",
    downloadCv: "CV බාගත කරන්න",
    withdraw: "ආපසු ගන්න",
    withdrawing: "ආපසු ගනිමින්...",
    withdrawTitle: "අයදුම්පත ආපසු ගනු",
    withdrawDescription: "\"{jobTitle}\" සඳහා ඔබගේ අයදුම්පත ආපසු ගැනීමට ඔබට අවශ්‍ය බව විශ්වාසද? මෙම ක්‍රියාව ආපසු හැරවිය නොහැක.",
    withdrawSuccess: "අයදුම්පත සාර්ථකව ආපසු ගන්නා ලදී",
    withdrawError: "අයදුම්පත ආපසු ගැනීමට අසමත් විය",
    loadError: "ඔබගේ අයදුම්පත් පැටවීමට අසමත් විය",
    browseJobs: "රැකියා සොයන්න",
    previous: "පෙර",
    next: "ඊළඟ",
    pageOf: "පිටුව {current} / {total}",
    remote: "දුරස්ථ"
  },

  // Job Management
  jobManagement: {
    title: "රැකියා කළමනාකරණය",
    subtitle: "ඔබේ රැකියා ලැයිස්තුගත කිරීම් කළමනාකරණය කරන්න සහ කාර්ය සාධනය නිරීක්ෂණය කරන්න",
    postNewJob: "නව රැකියාවක් පළ කරන්න",
    noJobsTitle: "තවම රැකියා ලැයිස්තුගත කිරීම් නොමැත",
    noJobsDescription: "ඔබේ පළමු රැකියා ලැයිස්තුගත කිරීම පළ කිරීමෙන් ආරම්භ කරන්න",
    postFirstJob: "ඔබේ පළමු රැකියාව පළ කරන්න",
    view: "බලන්න",
    edit: "සංස්කරණය",
    delete: "මකන්න",
    aiMatch: "AI ගැලපීම",
    applications: "අයදුම්පත්",
    posted: "පළ කළ",
    salary: "වැටුප",
    salaryNotSpecified: "වැටුප සපයා නැත",
    jobDetails: "රැකියා විස්තර",
    description: "විස්තරය",
    requirements: "අවශ්‍යතා",
    benefits: "ප්‍රතිලාභ",
    skills: "කුසලතා",
    deleteConfirmTitle: "රැකියා ලැයිස්තුව මකන්න",
    deleteConfirmDescription: "ඔබට මෙම රැකියා ලැයිස්තුව මකා දැමීමට අවශ්‍යද? මෙම ක්‍රියාව අනුගමනය කළ නොහැක.",
    cancel: "අවලංගු කරන්න",
    confirm: "මකන්න",
    deleteSuccess: "රැකියා ලැයිස්තුව සාර්ථකව මකා දමන ලදි",
    deleteError: "රැකියා ලැයිස්තුව මකා දැමීමට අසමත් විය",
    aiMatchingTitle: "AI-ගැලපුණු අපේක්ෂකයින්",
    aiMatchingSubtitle: "කෘත්‍රිම බුද්ධිය භාවිතා කරමින් ගැලපුණු ප්‍රමුඛ අපේක්ෂකයින්",
    upgradeRequired: "උන්නතිකරණය අවශ්‍ය",
    aiMatchingUpgradeMessage: "AI ගැලපීම BPO සහ Bulk Plan සහ Enterprise Annual සැලැස්ම් සඳහා පමණි",
    matchPercentage: "ගැලපීම %",
    experience: "අත්දැකීම්",
    viewCV: "CV බලන්න",
    years: "වසර",
    noMatchedCandidates: "ගැලපුණු අපේක්ෂකයින් නොමැත",
    fetchingCandidates: "සුදුසු අපේක්ෂකයින් ලබාගනිමින්...",
    fetchCandidatesError: "සුදුසු අපේක්ෂකයින් ලබාගැනීමට අසමත් විය",
    loadingJobs: "රැකියා ලැයිස්තුගත කිරීම් ලෝඩ් වෙමින්...",
    fetchJobsError: "රැකියා ලැයිස්තුගත කිරීම් ලබාගැනීමට අසමත් විය",
    createJob: "නව රැකියාවක් සාදන්න",
    editJob: "රැකියාව සංස්කරණය කරන්න",
    viewApplications: "අයදුම්පත් බලන්න",
    jobTitle: "රැකියා නාමය",
    company: "සමාගම",
    location: "ස්ථානය",
    status: "තත්ත්වය",
    postedDate: "පළ කළ දිනය",
    actions: "ක්‍රියාමාර්ග",
    searchJobs: "රැකියා සොයන්න...",
    filterByStatus: "තත්ත්වය අනුව පෙරහන් කරන්න",
    allStatuses: "සියලු තත්ත්වයන්",
    noJobs: "රැකියා සොයාගත නොහැකි විය",
    createJobDescription: "ආරම්භ කිරීම සඳහා ඔබේ පළමු රැකියාව සාදන්න."
  },

  // ATS (Applicant Tracking System)
  ats: {
    title: "අයදුම්කරු ප්‍රතිපාදන පද්ධතිය",
    subtitle: "අයදුම්පත් සහ කෙටිලැයිස්තුගත අපේක්ෂකයින් කළමනාකරණය කරන්න",
    jobApplications: "රැකියා අයදුම්පත්",
    shortlistedCandidates: "කෙටිලැයිස්තුගත අපේක්ෂකයින්",
    selectJobListing: "රැකියා ලැයිස්තුවක් තෝරන්න",
    allApplications: "සියලුම අයදුම්පත්",
    pending: "පොරොත්තුවෙන්",
    reviewing: "සමාලෝචනය කරමින්",
    shortlisted: "කෙටිලැයිස්තුගත කරන්න",
    rejected: "ප්‍රතික්ෂේප කරන්න",
    hired: "බඳවා ගත්",
    loadingApplications: "අයදුම්පත් ලෝඩ් වෙමින්...",
    noApplicationsFound: "මෙම පෙරහන සඳහා අයදුම්පත් නොමැත",
    match: "ගැලපීම",
    calculateMatch: "ගැලපීම ගණනය කරන්න",
    appliedOn: "අයදුම් කළ දිනය",
    viewApplication: "අයදුම්පත බලන්න",
    viewCV: "CV බලන්න",
    updateStatus: "තත්ත්වය යාවත්කාලීන කරන්න",
    addNotes: "සටහන් එක් කරන්න",
    notesPlaceholder: "මෙම අයදුම්පත පිළිබඳ සටහන් එක් කරන්න...",
    updateStatusSuccess: "අයදුම්පත තත්ත්වය යාවත්කාලීන කරන ලදි",
    updateStatusError: "අයදුම්පත තත්ත්වය යාවත්කාලීන කිරීමට අසමත් විය",
    matchCalculateSuccess: "ගැලපීම ලකුණ ගණනය කරන ලදි:",
    matchCalculateError: "ගැලපීම ලකුණ ගණනය කිරීමට අසමත් විය",
    openCVError: "CV විවෘත කිරීමට අසමත් විය",
    coverLetter: "ආවරණ ලිපිය",
    candidateName: "අපේක්ෂකයාගේ නම",
    contactedOn: "සම්බන්ධ කර ගත් දිනය",
    notContacted: "සම්බන්ධ කර නොගත්",
    sample: "සාම්පලය",
    fetchJobsError: "ඔබේ රැකියා ලැයිස්තුගත කිරීම් ලබාගැනීමට අසමත් විය",
    fetchApplicationsError: "අයදුම්පත් ලබාගැනීමට අසමත් විය",
    shortlistedCandidatesCount: "කෙටිලැයිස්තුගත අපේක්ෂකයින්",
    searchMoreCandidates: "වැඩි අපේක්ෂකයින් සොයන්න",
    noShortlistedTitle: "තවම අපේක්ෂකයින් කෙටිලැයිස්තුගත කර නැත",
    noShortlistedDescription: "විභව අපේක්ෂකයින් සොයා කෙටිලැයිස්තුගත කිරීමට අපේක්ෂක සෙවීම් විශේෂාංගය භාවිතා කරන්න.",
    searchCandidates: "අපේක්ෂකයින් සොයන්න",
    shortlistedOn: "කෙටිලැයිස්තුගත කළ දිනය",
    experience: "අත්දැකීම්",
    notice: "දැනුම්දීම",
    keySkills: "ප්‍රධාන කුසලතා",
    notes: "සටහන්",
    viewProfile: "පැතිකඩ බලන්න",
    contacted: "සම්බන්ධ කර ගත්",
    contact: "සම්බන්ධ කර ගන්න",
    contactSuccess: "අපේක්ෂකයා සාර්ථකව සම්බන්ධ කර ගන්නා ලදි",
    contactError: "සම්බන්ධතා තත්ත්වය යාවත්කාලීන කිරීමට අසමත් විය",
    cvAvailable: "CV ලබා ගත හැකිය",
    years: "වසර",
    connectATS: "ATS සම්බන්ධ කරන්න",
    manageConnections: "සම්බන්ධතා කළමනාකරණය කරන්න",
    supportedPlatforms: "සහාය දක්වන වේදිකා",
    benefits: {
      title: "ATS ඒකාබද්ධකරණයේ ප්‍රතිලාභ",
      seamlessSync: "අයදුම්පත් අඛණ්ඩ සමමුහුර්තකරණය",
      centralizedManagement: "මධ්‍යගත අපේක්ෂක කළමනාකරණය",
      automatedWorkflow: "ස්වයංක්‍රීය සේවා ප්‍රවාහ",
      enhancedReporting: "වැඩිදියුණු කළ වාර්තාකරණය"
    }
  },

  // Candidate Search
  candidateSearch: {
    title: "සෙවුම් පෙරහන්",
    requiredFields: "අවශ්‍ය: (රැකියා නාමය + අත්දැකීම් මට්ටම) හෝ කුසලතා/මූල පද ඇතුළත් කරන්න",
    jobTitle: "රැකියා නාමය",
    jobTitlePlaceholder: "උදා: Software Engineer",
    experienceLevel: "අත්දැකීම් මට්ටම",
    experienceLevelPlaceholder: "අත්දැකීම් මට්ටම තෝරන්න",
    location: "ස්ථානය",
    locationPlaceholder: "ස්ථානය තෝරන්න",
    skillsKeywords: "කුසලතා/මූල පද",
    skillsPlaceholder: "උදා: React, Node.js, Python",
    additionalFilters: "අමතර පෙරහන් (විකල්ප)",
    candidateName: "අපේක්ෂකයාගේ නම",
    candidateNamePlaceholder: "නම ඇතුළත් කරන්න...",
    availableOverseas: "විදේශ ගතව ලබා ගත හැකි",
    availabilityPlaceholder: "ලබා ගැනීමේ හැකියාව තෝරන්න",
    visaStatus: "වීසා තත්ත්වය",
    visaStatusPlaceholder: "වීසා තත්ත්වය තෝරන්න",
    searchCandidates: "අපේක්ෂකයින් සොයන්න",
    resetFilters: "පෙරහන් යළි පිහිටුවන්න",
    experienceLevels: {
      entry: "ආරම්භක මට්ටම",
      mid: "මධ්‍යම මට්ටම",
      senior: "ජ්‍යෙෂ්ඨ මට්ටම",
      lead: "ප්‍රමුඛ/කළමනාකරු",
      executive: "විධායක"
    },
    availability: {
      all: "සියල්ල",
      yes: "ඔව්",
      no: "නැත"  
    },
    visaStatuses: {
      all: "සියල්ල",
      citizen: "පුරවැසි",
      permanent_resident: "ස්ථීර පදිංචිකරුවා",
      work_visa: "රැකියා වීසාව",
      student_visa: "ශිෂ්‍ය වීසාව",
      tourist_visa: "සංචාරක වීසාව",
      none: "වීසාව නැත"
    },
    readyToSearch: "අපේක්ෂකයින් සෙවීමට සූදානම්",
    searchInstruction: "ඔබේ සෙවීම ආරම්භ කිරීමට රැකියා නාමයක් සහ අත්දැකීම් මට්ටමක් හෝ කුසලතා/මූල පද ඇතුළත් කරන්න.",
    searchError: "සෙවීමට කරුණාකර (රැකියා නාමය + අත්දැකීම් මට්ටම) හෝ කුසලතා/මූල පද ඇතුළත් කරන්න",
    loadingAuth: "සත්‍යාපනය ලෝඩ් වෙමින්...",
    redirecting: "හරවා යැවෙමින්...",
    shortlist: "කෙටිලැයිස්තුව",
    contact: "සම්බන්ධ කර ගන්න",
    viewCV: "CV බලන්න",
    shortlisted: "කෙටිලැයිස්තුගත",
    contacted: "සම්බන්ධ කර ගත්",
    years: "වසර",
    experience: "අත්දැකීම්",
    keySkills: "ප්‍රධාන කුසලතා",
    overseas: "ගෝලීය",
    visa: "වීසාව",
    noResults: "අපේක්ෂකයින් සොයාගත නොහැකි විය",
    searchErrorMessage: "වැඩි අපේක්ෂකයින් සෙවීමට ඔබේ සෙවුම් පෙරහන් සකසා දෙන්න."
  },

  // Post Job
  postJob: {
    jobDetails: "රැකියා විස්තර",
    unlimitedJobs: "අසීමිත රැකියා",
    jobsUsed: "භාවිතා කළ රැකියා",
    company: "සමාගම",
    selectCompany: "සමාගමක් තෝරන්න",
    newCompany: "නව සමාගම",
    createNewCompany: "නව සමාගමක් සාදන්න",
    cancel: "අවලංගු කරන්න",
    companyLogo: "සමාගම් ලාංඡනය",
    uploadLogo: "ලාංඡනය උඩුගත කරන්න",
    uploading: "උඩුගත කරමින්...",
    imageFormats: "PNG, JPG 5MB දක්වා",
    companyName: "සමාගමේ නම *",
    companyNamePlaceholder: "සමාගමේ නම ඇතුළත් කරන්න",
    website: "වෙබ් අඩවිය",
    websitePlaceholder: "https://company.com",
    industry: "කර්මාන්තය",
    industryPlaceholder: "උදා: තාක්ෂණය, මූල්‍ය",
    companySize: "සමාගමේ ප්‍රමාණය",
    selectSize: "ප්‍රමාණය තෝරන්න",
    employees1to10: "සේවකයන් 1-10",
    employees11to50: "සේවකයන් 11-50",
    employees51to200: "සේවකයන් 51-200",
    employees201to500: "සේවකයන් 201-500",
    employees500plus: "සේවකයන් 500+",
    companyDescription: "සමාගම් විස්තරය",
    companyDescriptionPlaceholder: "සමාගම පිළිබඳ කෙටි විස්තරයක්",
    createCompany: "සමාගම සාදන්න",
    jobTitle: "රැකියා නාමය *",
    jobTitlePlaceholder: "උදා: ජ්‍යෙෂ්ඨ මෘදුකාංග ඉංජිනේරු",
    location: "ස්ථානය *",
    locationPlaceholder: "උදා: කොළඹ, ශ්‍රී ලංකාව",
    jobType: "රැකියා වර්ගය *",
    selectJobType: "රැකියා වර්ගය තෝරන්න",
    fullTime: "පූර්ණ කාලීන",
    partTime: "අර්ධ කාලීන",
    contract: "කොන්ත්‍රාත්තු",
    internship: "සීමාව",
    experienceLevel: "අත්දැකීම් මට්ටම *",
    selectExperienceLevel: "අත්දැකීම් මට්ටම තෝරන්න",
    entryLevel: "ආරම්භක මට්ටම",
    midLevel: "මධ්‍යම මට්ටම",
    senior: "ජ්‍යෙෂ්ඨ",
    executive: "විධායක",
    minSalary: "අවම වැටුප (LKR/මාසය)",
    minSalaryPlaceholder: "උදා: 50000",
    maxSalary: "උපරිම වැටුප (LKR/මාසය)",
    maxSalaryPlaceholder: "උදා: 80000",
    remoteWork: "දුරස්ථ කාර්යය ලබා ගත හැකි",
    urgentHiring: "හදිසි බඳවා ගැනීමක් ලෙස සලකුණු කරන්න",
    urgentBadgeActive: "හදිසි ලාංඡනය සක්‍රීය",
    addUrgentBadge: "හදිසි බඳවා ගැනීම් ලාංඡනය එක් කරන්න",
    urgentPaymentNotice: "මෙම හදිසි රැකියාව පළ කිරීමට පෙර ඔබව ගෙවීම් පිටුවට හරවා යවනු ලැබේ.",
    requiredSkills: "අවශ්‍ය කුසලතා (කොමා වෙන්කර)",
    skillsPlaceholder: "උදා: React, Node.js, PostgreSQL",
    applicationDeadline: "අයදුම්පත් අවසාන දිනය",
    jobDescription: "රැකියා විස්තරය *",
    jobDescriptionPlaceholder: "භූමිකාව, වගකීම් සහ ඔබ සොයන දේ විස්තර කරන්න...",
    requirements: "අවශ්‍යතා",
    requirementsPlaceholder: "අවශ්‍ය සුදුසුකම්, අත්දැකීම් සහ කුසලතා ලැයිස්තුගත කරන්න...",
    benefits: "ප්‍රතිලාභ",
    benefitsPlaceholder: "ප්‍රතිලාභ, දීමනා සහ වැටුප් විස්තර ලැයිස්තුගත කරන්න...",
    postJob: "රැකියාව පළ කරන්න",
    payAndPostUrgent: "ගෙවා හදිසි රැකියාව පළ කරන්න",
    processing: "සකසමින්...",
    jobPostingLimitReached: "රැකියා පළ කිරීමේ සීමාව ළඟා වී ඇත",
    limitReachedMessage: "ඔබ ඔබේ {plan} සැලැස්මේ සියලු {count} රැකියා පළ කිරීම් භාවිතා කර ඇත",
    upgradePlan: "සැලැස්ම උන්නත කරන්න",
    almostAtLimit: "ඔබේ සීමාවට ආසන්න",
    limitWarningMessage: "ඔබේ {plan} සැලැස්මේ {count} රැකියා පළ කිරීම් ඉතිරිව ඇත",
    viewUpgrades: "උන්නතිකරණ බලන්න",
    loading: "ලෝඩ් වෙමින්..."
  },

  // Payment & Checkout
  payment: {
    orderSummary: "ඇණවුම් සාරාංශය",
    selectedPlan: "තෝරාගත් සැලැස්ම",
    planPrice: "සැලැස්මේ මිල:",
    addons: "අමතර සේවා:",
    addonsSubtotal: "අමතර සේවා උප එකතුව:",
    billing: "බිල්පත් කිරීම:",
    duration: "කාලසීමාව:",
    total: "මුළු එකතුව:",
    paymentDetails: "ගෙවීමේ විස්තර",
    billingEmail: "බිල්පත් කිරීමේ ඊමේල්",
    selectPaymentMethod: "ගෙවීමේ ක්‍රමය තෝරන්න",
    creditCard: "ක්‍රෙඩිට් කාඩ්පත",
    viaStripe: "Stripe හරහා",
    usdt: "USDT",
    viaCoinbase: "Coinbase හරහා",
    secureStripePayment: "Stripe සමඟ ආරක්ෂිත ගෙවීම",
    stripeDescription: "ඔබේ ගෙවීම Stripe හරහා ආරක්ෂිතව සැකසෙනු ඇත",
    payWithUsdt: "USDT සමඟ ගෙවන්න",
    coinbaseDescription: "Coinbase Commerce විසින් බලගන්වන ලද ආරක්ෂිත USDT ගෙවීම්",
    processing: "සැකසෙමින්...",
    proceedToPayment: "ගෙවීම සඳහා ඉදිරියට යන්න",
    termsNotice: "ඉදිරියට යාමෙන්, ඔබ අපගේ සේවා කොන්දේසි සහ පෞද්ගලිකත්ව ප්‍රතිපත්තියට එකඟ වන බව. ඔබේ දායකත්වය අවලංගු නොකළහොත් එය ස්වයංක්‍රීයව අලුත් වනු ඇත.",
    loadingCheckout: "චෙක්අවුට් පූරණය වෙමින්...",
    oneTimePayment: "එක් වරක් ගෙවීම",
    perMonth: "මාසිකව",
    perYear: "වාර්ෂිකව",
    days: "දින"
  },

  // ATS Integration  
  atsIntegration: {
    title: "සම්පූර්ණ ATS අභ්‍යන්තරව ගොඩනගා ඇත",
    subtitle: "ඔබට අවශ්‍ය සියල්ල අභ්‍යන්තරව ගොඩනගා ඇති විට බාහිර පද්ධති සමඟ ඒකාබද්ධ වන්නේ ඇයි? GreatJobs.lk කාර්යක්ෂම බඳවාගැනීම සඳහා විශේෂයෙන් නිර්මාණය කරන ලද සම්පූර්ණ අයදුම්කරු ලුහුබැඳීමේ පද්ධතියක් සපයයි.",
    badge: "බාහිර ATS අවශ්‍ය නැත",
    builtInFeatures: {
      title: "මිනිත්තු කිහිපයකින් ආරම්භ කරන්න",
      description: "සංකීර්ණ ඒකාබද්ධතා සහ දිගු පිහිටුවීමේ ක්‍රියාවලි මඟහරින්න. ඔබේ ව්‍යාපාරික අවශ්‍යතා සමඟ වර්ධනය වන අපගේ සහජ, සියල්ල-එක-තැන වේදිකාව සමඟ වහාම බඳවාගැනීම ආරම්භ කරන්න.",
      postFirstJob: "ඔබේ පළමු රැකියාව පළ කරන්න",
      browseCandidates: "අපේක්ෂකයින් සොයන්න",
      jobManagement: {
        title: "සම්පූර්ණ රැකියා කළමනාකරණය",
        description: "උසස් ඉලක්ක කිරීමේ විකල්ප සහ තත්‍ය-කාලීන විශ්ලේෂණ සමඟ රැකියා ලැයිස්තු පළ කරන්න, සංස්කරණය කරන්න සහ කළමනාකරණය කරන්න"
      },
      candidateSearch: {
        title: "උසස් අපේක්ෂක සෙවීම", 
        description: "AI බලගන්වන ගැලපීම සහ පෙරහන් කිරීම සමඟ දහස් ගණන් සුදුසුකම් සම්පන්න අපේක්ෂකයින් සොයන්න"
      },
      applicantTracking: {
        title: "අයදුම්කරු ලුහුබැඳීම",
        description: "අයදුම්පත් ලුහුබැඳින්න, අපේක්ෂක නල මාර්ග කළමනාකරණය කරන්න, සහ ඔබේ බඳවාගැනීමේ කණ්ඩායම සමඟ සහයෝගයෙන් කටයුතු කරන්න"
      },
      analytics: {
        title: "බඳවාගැනීමේ විශ්ලේෂණ",
        description: "රැකියා කාර්ය සාධනය, අපේක්ෂක ගුණාත්මකභාවය සහ බඳවාගැනීමේ ප්‍රමිතික පිළිබඳ සවිස්තරාත්මක අවබෝධයක් ලබා ගන්න"
      },
      notifications: {
        title: "බුද්ධිමත් දැනුම්දීම්",
        description: "අයදුම්පත් තත්ත්ව යාවත්කාලීන කිරීම් සහ නව අවස්ථා පිළිබඳ අපේක්ෂකයින්ට ස්වයංක්‍රීය SMS සහ ඊමේල් දැනුම්දීම්"
      },
      shortlisting: {
        title: "අපේක්ෂක කෙටිලැයිස්තුකරණය",
        description: "සටහන් සහ ශ්‍රේණිගත කිරීමේ පද්ධති සමඟ බලාපොරොත්තු සහගත අපේක්ෂකයින් සුරකින්න සහ සංවිධානය කරන්න"
      }
    },
    externalIntegrations: {
      title: "අමතරව බාහිර ඒකාබද්ධතා ලබා ගත හැකිය",
      description: "ඔබ දැනටමත් බාහිර ATS එකක් භාවිතා කරනවාද? ප්‍රශ්නයක් නැත. අපි ප්‍රමුඛ වේදිකා සමඟ බාධාකාරී ඒකාබද්ධතා ද ලබා දෙමු.",
      benefits: {
        sync: {
          title: "ක්ෂණික සමමුහූර්තකරණය",
          description: "GreatJobs.lk සහ ඔබේ ATS වේදිකාව අතර තත්‍ය-කාලීන දත්ත සමමුහූර්තකරණය"
        },
        security: {
          title: "ආරක්ෂිත දත්ත හුවමාරුව", 
          description: "සංකේතාත්මක API සම්බන්ධතා සමඟ ව්‍යවසායික-ශ්‍රේණියේ ආරක්ෂාව"
        },
        workflow: {
          title: "විධිමත් කාර්යප්‍රවාහය",
          description: "අතින් දත්ත ඇතුළත් කිරීම ඉවත් කරන්න සහ බඳවාගැනීමේ කාලය අඩු කරන්න"
        },
        compliance: {
          title: "අනුකූලතාවට සූදානම්",
          description: "GDPR සහ දේශීය අනුකූලතා ප්‍රමිතීන් ස්වයංක්‍රීයව පවත්වාගන්න"
        }
      }
    },
    supportedPlatforms: {
      title: "සහාය දක්වන ATS වේදිකා",
      description: "බාධාකාරී කාර්යප්‍රවාහ ගැළපුම සහතික කිරීම සඳහා අපි ප්‍රමුඛ අයදුම්කරු ලුහුබැඳීමේ පද්ධති සමඟ ඒකාබද්ධ වෙමු.",
      workday: {
        name: "Workday",
        description: "තත්‍ය-කාලීන සමමුහූර්තකරණය සමඟ සම්පූර්ණ HCM ඒකාබද්ධතාව",
        features: ["අපේක්ෂක සමමුහූර්තකරණය", "රැකියා පළකිරීමේ ස්වයංක්‍රීයකරණය", "විශ්ලේෂණ ඒකාබද්ධතාව"]
      },
      bamboohr: {
        name: "BambooHR",
        description: "සියල්ල-එක-තැන HR වේදිකා ඒකාබද්ධතාව", 
        features: ["සේවක ආරම්භකරණය", "කාර්ය සාධන ලුහුබැඳීම", "ලේඛන කළමනාකරණය"]
      },
      greenhouse: {
        name: "Greenhouse",
        description: "උසස් බඳවාගැනීමේ මෘදුකාංග සම්බන්ධතාව",
        features: ["සම්මුඛ පරීක්ෂණ කාලසටහන් කිරීම", "ලකුණු කාඩ්පත් ඒකාබද්ධතාව", "නල මාර්ග කළමනාකරණය"]
      },
      lever: {
        name: "Lever", 
        description: "නවීන දක්ෂතා අත්පත් කර ගැනීමේ වේදිකාව",
        features: ["CRM ඒකාබද්ධතාව", "සහයෝගී බඳවාගැනීම", "දත්ත විශ්ලේෂණය"]
      },
      icims: {
        name: "iCIMS",
        description: "සම්පූර්ණ දක්ෂතා වලාකුළු විසඳුම",
        features: ["දක්ෂතා අත්පත් කර ගැනීම", "ශ්‍රම බල කළමනාකරණය", "අනුකූලතා ලුහුබැඳීම"]
      },
      smartrecruiters: {
        name: "SmartRecruiters",
        description: "ව්‍යවසායික බඳවාගැනීමේ වේදිකාව",
        features: ["ගෝලීය බඳවාගැනීම", "AI බලගන්වන ගැලපීම", "සැපයුම්කරු කළමනාකරණය"]
      }
    },
    cta: {
      title: "ඔබේ ATS ඒකාබද්ධ කිරීමට සූදානම්ද?",
      description: "අපගේ සම්පූර්ණ ඒකාබද්ධතා වේදිකාව සමඟ ආරම්භ කරන්න සහ අදම ඔබේ බඳවාගැනීමේ ක්‍රියාවලිය පරිවර්තනය කරන්න.",
      signUp: "දැන් ලියාපදිංචි වන්න"
    }
  },

  // Testimonials
  testimonials: {
    title: "වෘත්තිකයින් ශ්‍රී ලංකාවේ පළමු AI බලගන්වන දක්ෂතා විසඳුම තෝරා ගන්නේ ඇයි",
    subtitle: "ශ්‍රී ලංකාව විශ්වාස කරන හොඳම රැකියා පුවරුව හරහා ඔවුන්ගේ සිහින රැකියාව සොයාගත් දහස් ගණන් වෘත්තිකයන්ට එක්වන්න",
    testimonial1: {
      name: "රවින්දු පෙරේරා",
      role: "මෘදුකාංග ඉංජිනේරු",
      company: "ටෙක්ෆ්ලෝ සොලියුෂන්ස්",
      content: "සති 2කින් කොළඹ IT රැකියාව සොයාගත්තා! AI ගැලපීම් විශේෂාංගය අමුතුයි - එය මට වෙනත් තැනකින් සොයාගන්න බෑ අවස්ථා සම්බන්ධ කළා. මේක නිසැකවම ශ්‍රී ලංකාවේ හොඳම රැකියා පුවරුව."
    },
    testimonial2: {
      name: "සමන්ත ප්‍රනාන්දු",
      role: "මූල්‍ය විධායක", 
      company: "ලංකා බැංකුව",
      content: "අලුත් උපාධිධාරියෙක් වශයෙන්, ශ්‍රී ලංකාවේ ආරම්භක මට්ටමේ මූල්‍ය රැකියා සොයා ගැනීමට මම අරගල කරමින් සිටියෙමි. GreatJobs.lk හි ඉලක්කගත ගැලපීම මට ප්‍රමුඛ බැංකුවක මගේ පළමු රැකියාව ලබා ගැනීමට උදව් කළා."
    },
    testimonial3: {
      name: "කසුන් සිල්වා",
      role: "මානව සම්පත් කළමනාකරු",
      company: "ක්‍රිએටිව් ඩිජිටල්", 
      content: "අපි බොහෝ වේදිකා උත්සාහ කර ඇත, නමුත් GreatJobs.lk ශ්‍රී ලංකාවේ පළමු AI රැකියා පුවරුව ලෙස කැපී පෙනේ. අපි මෙහි පළ කරන කොළඹ IT රැකියා සඳහා කුසල දේවලොපර්වරුන්ගෙන් හොඳම ප්‍රතිචාර ලැබේ."
    },
    testimonial4: {
      name: "නිමාලි ජයසිංහ",
      role: "අලෙවිකරණ විශේෂඥ",
      company: "ග්‍රෝත් ලැබ්ස්",
      content: "රැකියා ඇඟවීම් පද්ධතිය අතිමහත්! මට අදාළ අවස්ථා ගැන තත්‍යකාලීනව දැනුම් දෙනවා. මේකයි ශ්‍රී ලංකාවේ හොඳම රැකියා පුවරුව ලෙස සලකන්නේ - පරිශීලක අත්දැකීම නිරුපමයි."
    },
    testimonial5: {
      name: "චතුර මෙන්ඩිස්",
      role: "දත්ත විශ්ලේෂක",
      company: "ඇනලිටික්ස් ප්‍රෝ",
      content: "සාම්ප්‍රදායික රැකියා වෙබ්සයිට් මාස ගණනක් සොයීමෙන් පසුව, මම GreatJobs.lk සොයාගත්තා. දින කිහිපයකින්, මගේ කුසලතාවන්ට පරිපූර්ණව ගැලපෙන කොළඹ IT රැකියා සඳහා සම්මුඛ පරීක්ෂණ සකසා තිබුණා."
    },
    testimonial6: {
      name: "ප්‍රියංකා වික්‍රමසිංහ",
      role: "මූල්‍ය විශ්ලේෂක",
      company: "ඉන්වෙස්ට්මෙන්ට් පාර්ට්නර්ස්",
      content: "මගේ වෘත්තීය ජීවිතය ආරම්භ කිරීම අභියෝගාත්මක විය, මම මෙම වේදිකාව සොයාගන්නා තුරු. ශ්‍රී ලංකාවේ ආරම්භක මට්ටමේ මූල්‍ය රැකියා අංශයේ මට අවශ්‍ය දේ හරියටම තිබුණා."
    }
  },

  // Common
  common: {
    loading: "ලෝඩ් වෙමින්...",
    search: "සොයන්න",
    location: "ස්ථානය",
    jobType: "රැකියා වර්ගය",
    experienceLevel: "අත්දැකීම් මට්ටම",
    fullTime: "පූර්ණ කාලීන",
    partTime: "අර්ධ කාලීන", 
    contract: "කොන්ත්‍රාත්තු",
    freelance: "ස්වාධීන",
    internship: "සීමාව",
    entry: "ආරම්භක මට්ටම",
    mid: "මධ්‍යම මට්ටම",
    senior: "ජ්‍යෙෂ්ඨ",
    executive: "විධායක",
    active: "සක්‍රීය",
    paused: "තාවකාලිකව නතර කළ",
    closed: "වසා දැමූ",
    remote: "දුරස්ථ"
  }
};